// frontend/src/components/ProfileSelector.js
import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Box,
  Avatar,
  Typography,
} from "@mui/material";
// import { useTranslation } from "react-i18next";

// components/ProfileSelector.js
const ProfileSelector = ({ profiles, currentProfile, onProfileChange }) => {
  if (!profiles?.length) return null;

  return (
    <FormControl size="small">
      <Select
        value={currentProfile?.id || ""}
        onChange={(e) => onProfileChange(e.target.value)}
        displayEmpty
        sx={{
          minWidth: 150,
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: 1,
          },
        }}
      >
        {profiles?.map((profile) => (
          <MenuItem key={profile.id} value={profile.id}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar src={profile.logoUrl} sx={{ width: 24, height: 24 }}>
                {profile.name?.charAt(0)}
              </Avatar>
              <Typography>{profile.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProfileSelector;
